module.exports = __webpack_public_path__ + "media/images/flags/16/Malaysia-6e412c32a6856dbb2877cf7a1bfdef04.png";